"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";

export function SearchInputPopoverHeading({ text = "OUR LOCATIONS" }) {
  return (
    <Block className={"search-popover-heading"} tag={"div"}>
      <Block className={"text-46"} tag={"div"}>
        {text}
      </Block>
      <Block className={"search---divider"} tag={"div"} />
    </Block>
  );
}
